var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center py-15"},[_c('v-icon',{staticClass:"mb-4",attrs:{"size":"70","color":"grey lighten-2"}},[_vm._v(" mdi-folder-hidden ")]),_c('div',{staticClass:"text-h5 font-weight-light",attrs:{"color":"grey"}},[_vm._v(" "+_vm._s(_vm.$t('noResultFound'))+" ")]),_c('div',{staticClass:"mt-2"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }